import styled from "@emotion/styled";
import { Container } from "@mui/material";

const createResponsiveStyles = (theme, styles) => {
  if (!styles || typeof styles !== "object") return {};
  const flat = {};
  const byBreakpoint = {};
  Object.entries(styles).forEach(([property, value]) => {
    if (value && typeof value === "object") {
      Object.entries(value).forEach(([bp, v]) => {
        if (bp === "xs") {
          flat[property] = v;
        } else {
          const mq = theme.breakpoints.up(bp);
          byBreakpoint[mq] = { ...(byBreakpoint[mq] || {}), [property]: v };
        }
      });
    } else {
      flat[property] = value;
    }
  });
  return { flat, byBreakpoint };
};

export const StyledSectionContainer = styled(Container)(({ theme, cssProps }) => {
  const { flat = {}, byBreakpoint = {} } = createResponsiveStyles(theme, cssProps);
  const lgKey = theme.breakpoints.up("lg");
  return {
    paddingBlock: "4rem",
    alignSelf: "center",

    [theme.breakpoints.up("md")]: {
      paddingInline: "0px !important",
    },
    [lgKey]: {
      paddingBlock: "6rem ",
      alignItems: "center",
      ...(byBreakpoint[lgKey] || {}),
      ...flat,
    },
    ...flat,
    ...Object.fromEntries(Object.entries(byBreakpoint).filter(([k]) => k !== lgKey)),
  };
});

export const StyledSectionContainerColorWrapper = styled("section")(({ theme, flipBackground }) => ({
  padding: "0 !important",
  margin: "0 !important",
  backgroundSize: "cover",
  backgroundImage: `url(${"https://d3a0rs3velfrz.cloudfront.net/bg-gradient.svg"})`,
  position: "relative",
  zIndex: 1,
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${"https://d3a0rs3velfrz.cloudfront.net/bg-gradient.svg"})`,
    backgroundSize: "cover",
    transform: flipBackground ? "scale(-1, -1)" : "none",

    zIndex: -1,
    opacity: 1,
  },
}));

export const StyledSectionContainerWhiteWrapper = styled("section")(({ theme }) => ({
  padding: "0 !important",
  margin: "0 !important",
  backgroundColor: theme.palette.background.default,
}));
